module.exports = __webpack_public_path__ + "static/media/youtube2.d18ff25f.svg";